<template>
	<nav
		class="site_header"
		:class="{ scrolled: isScrolled }"
		ref="site_header"
		@mouseover="show = true"
		@mouseleave="show = false"
	>
		<div class="top" v-if="window.width < 1280">
			<top-button
				v-if="parsedGlobalSettings"
				:link="parsedGlobalSettings.general.cta"
				:label="parsedGlobalSettings.general.cta.title"
				:target="parsedGlobalSettings.general.cta.target"
				type="cta"
			></top-button>
		</div>

		<div class="desktop_menu container" v-if="window.width >= 1280">
			<a href="/" class="site_header-brand"
				><img
					:src="
						parsedGlobalSettings.general.logo
							? parsedGlobalSettings.general.logo
							: logo
					"
					alt="Todmorden"
			/></a>

			<div class="center">
				<ul v-if="parsedMenu">
					<menu-item
						v-for="(menu_item, index) in parsedMenu"
						:key="index"
						:menu_item="menu_item"
						:has-children="menu_item.children ? true : false"
						:selected="menu_item.object_id == Number(currentId)"
						:locale="locale"
					>
					</menu-item>
				</ul>
			</div>

			<!-- <div class="center center-right">
				<ul v-if="parsedSecondaryMenu">
					<secondary-menu-item
						v-for="(menu_item, index) in parsedSecondaryMenu"
						:key="index"
						:menu_item="menu_item"
						:has-children="menu_item.children ? true : false"
						:selected="menu_item.object_id == Number(currentId)"
						:locale="locale"
					>
					</secondary-menu-item>
				</ul>
			</div> -->

			<div class="right">
				<div class="search" @click="toggleSearch">
					<svg
						width="26"
						height="25"
						viewBox="0 0 26 25"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M2.88583 10.131C2.88583 5.64037 6.52621 2 11.0168 2C15.5075 2 19.1478 5.64037 19.1478 10.131C19.1478 14.6216 15.5075 18.262 11.0168 18.262C6.52621 18.262 2.88583 14.6216 2.88583 10.131ZM11.0168 0C5.42164 0 0.885834 4.5358 0.885834 10.131C0.885834 15.7262 5.42164 20.262 11.0168 20.262C13.454 20.262 15.6902 19.4014 17.4381 17.9675L24.1783 24.7076L25.5925 23.2934L18.8524 16.5534C20.2869 14.8053 21.1478 12.5687 21.1478 10.131C21.1478 4.5358 16.612 0 11.0168 0Z"
							fill="#003764"
						/>
					</svg>
				</div>
				<!-- <close-button
					v-else
					@click.native="toggleSearch"
				></close-button> -->
				<top-button
					v-if="parsedGlobalSettings"
					:link="parsedGlobalSettings.general.cta"
					:label="parsedGlobalSettings.general.cta.title"
					:target="parsedGlobalSettings.general.cta.target"
					type="cta"
				></top-button>
			</div>
		</div>

		<transition name="bounce">
			<div
				class="desktop_menu scrolled"
				v-if="window.width >= 1280 && isScrolled"
			>
				<div class="container">
					<a href="/" class="site_header-brand"
						><img
							:src="
								parsedGlobalSettings.general.logo
									? parsedGlobalSettings.general.logo
									: logo
							"
							alt="Todmorden"
					/></a>

					<div class="center">
						<ul>
							<menu-item
								v-for="(menu_item, index) in parsedMenu"
								:key="index"
								:menu_item="menu_item"
								:has-children="menu_item.children ? true : false"
								:selected="menu_item.object_id == Number(currentId)"
								:locale="locale"
							>
							</menu-item>
						</ul>
					</div>

					<!-- <div class="center center-right">
						<ul v-if="parsedSecondaryMenu">
							<secondary-menu-item
								v-for="(menu_item, index) in parsedSecondaryMenu"
								:key="index"
								:menu_item="menu_item"
								:has-children="menu_item.children ? true : false"
								:selected="menu_item.object_id == Number(currentId)"
								:locale="locale"
							>
							</secondary-menu-item>
						</ul>
					</div> -->

					<div class="right">
						<div class="search" @click="toggleSearch">
							<svg
								width="26"
								height="25"
								viewBox="0 0 26 25"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M2.88583 10.131C2.88583 5.64037 6.52621 2 11.0168 2C15.5075 2 19.1478 5.64037 19.1478 10.131C19.1478 14.6216 15.5075 18.262 11.0168 18.262C6.52621 18.262 2.88583 14.6216 2.88583 10.131ZM11.0168 0C5.42164 0 0.885834 4.5358 0.885834 10.131C0.885834 15.7262 5.42164 20.262 11.0168 20.262C13.454 20.262 15.6902 19.4014 17.4381 17.9675L24.1783 24.7076L25.5925 23.2934L18.8524 16.5534C20.2869 14.8053 21.1478 12.5687 21.1478 10.131C21.1478 4.5358 16.612 0 11.0168 0Z"
								/>
							</svg>
						</div>
						<!-- <close-button
						v-else
						@click.native="toggleSearch"
					></close-button> -->
						<top-button
							v-if="parsedGlobalSettings"
							:link="parsedGlobalSettings.general.cta"
							:label="parsedGlobalSettings.general.cta.title"
							:target="parsedGlobalSettings.general.cta.target"
							type="cta"
						></top-button>
					</div>
				</div>
			</div>
		</transition>

		<div
			class="mobile_menu_nav container"
			v-if="!isScrolled && window.width < 1280"
		>
			<a href="/" class="site_header-brand"
				><img
					:src="
						parsedGlobalSettings.general.logo
							? parsedGlobalSettings.general.logo
							: logo
					"
					alt="Todmorden"
			/></a>

			<div class="right">
				<div class="search" @click="toggleSearch">
					<svg
						width="26"
						height="25"
						viewBox="0 0 26 25"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M2.88583 10.131C2.88583 5.64037 6.52621 2 11.0168 2C15.5075 2 19.1478 5.64037 19.1478 10.131C19.1478 14.6216 15.5075 18.262 11.0168 18.262C6.52621 18.262 2.88583 14.6216 2.88583 10.131ZM11.0168 0C5.42164 0 0.885834 4.5358 0.885834 10.131C0.885834 15.7262 5.42164 20.262 11.0168 20.262C13.454 20.262 15.6902 19.4014 17.4381 17.9675L24.1783 24.7076L25.5925 23.2934L18.8524 16.5534C20.2869 14.8053 21.1478 12.5687 21.1478 10.131C21.1478 4.5358 16.612 0 11.0168 0Z"
							fill="#003764"
						/>
					</svg>
				</div>
				<!-- <close-button
					v-else
					@click.native="toggleSearch"
				></close-button> -->

				<menu-button
					v-if="window.width <= 1280"
					@click.native="toggleMobileMenu()"
					:label="this.$store.state.mobile_menu ? 'Close' : 'Menu'"
					:type="this.$store.state.mobile_menu ? 'close' : 'open'"
				></menu-button>
			</div>
		</div>
		<transition name="bounce">
			<div
				class="mobile_menu_nav scrolled container"
				v-if="isScrolled && window.width < 1280"
			>
				<a href="/" class="site_header-brand"
					><img
						:src="
							parsedGlobalSettings.general.logo
								? parsedGlobalSettings.general.logo
								: logo
						"
						alt="Todmorden"
				/></a>

				<div class="right">
					<div class="search" @click="toggleSearch">
						<svg
							width="26"
							height="25"
							viewBox="0 0 26 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M2.88583 10.131C2.88583 5.64037 6.52621 2 11.0168 2C15.5075 2 19.1478 5.64037 19.1478 10.131C19.1478 14.6216 15.5075 18.262 11.0168 18.262C6.52621 18.262 2.88583 14.6216 2.88583 10.131ZM11.0168 0C5.42164 0 0.885834 4.5358 0.885834 10.131C0.885834 15.7262 5.42164 20.262 11.0168 20.262C13.454 20.262 15.6902 19.4014 17.4381 17.9675L24.1783 24.7076L25.5925 23.2934L18.8524 16.5534C20.2869 14.8053 21.1478 12.5687 21.1478 10.131C21.1478 4.5358 16.612 0 11.0168 0Z"
								fill="#003764"
							/>
						</svg>
					</div>
					<!-- <close-button
						v-else
						@click.native="toggleSearch"
					></close-button> -->

					<menu-button
						v-if="window.width <= 1240"
						@click.native="toggleMobileMenu()"
						:label="this.$store.state.mobile_menu ? 'Close' : 'Menu'"
						:type="this.$store.state.mobile_menu ? 'close' : 'open'"
					></menu-button>
				</div>
			</div>
		</transition>

		<mobile-menu
			v-if="window.width <= 1240"
			:is-showing="this.$store.state.mobile_menu"
			:current-id="Number(currentId)"
			:menu-data="parsedMobileMenu"
			:global-settings="parsedGlobalSettings"
			:class="{ alert_open: this.$store.state.alert_bar_closed === false }"
		>
		</mobile-menu>

		<transition name="fade">
			<div
				v-if="searchToggled"
				class="search_dropdown"
				ref="container"
				:class="{ scrolled: isScrolled }"
			>
				<div class="container">
					<div class="inner">
						<div class="search_form">
							<svg
								width="26"
								height="25"
								viewBox="0 0 26 25"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M2.88583 10.131C2.88583 5.64037 6.52621 2 11.0168 2C15.5075 2 19.1478 5.64037 19.1478 10.131C19.1478 14.6216 15.5075 18.262 11.0168 18.262C6.52621 18.262 2.88583 14.6216 2.88583 10.131ZM11.0168 0C5.42164 0 0.885834 4.5358 0.885834 10.131C0.885834 15.7262 5.42164 20.262 11.0168 20.262C13.454 20.262 15.6902 19.4014 17.4381 17.9675L24.1783 24.7076L25.5925 23.2934L18.8524 16.5534C20.2869 14.8053 21.1478 12.5687 21.1478 10.131C21.1478 4.5358 16.612 0 11.0168 0Z"
									fill="#003764"
								/>
							</svg>

							<form role="search" action="/" method="GET">
								<input
									type="text"
									name="s"
									value=""
									placeholder="Type to search..."
									ref="search"
								/>
							</form>
						</div>

						<close-button @click.native="toggleSearch"></close-button>
					</div>
				</div>
			</div>
		</transition>
		<transition-group name="slide-fade-vert" class="search-outer-wrapper">
			<div
				class="search-outer nectar"
				v-if="showSearch && window.width >= 1280"
				:key="1"
			>
				<div class="search">
					<div class="container" style="position: relative">
						<div class="searchbox">
							<div class="inner-wrap">
								<div class="col span_12">
									<form role="search" action="/" method="GET">
										<input
											type="text"
											name="s"
											value=""
											placeholder="Search"
											ref="search"
										/>
										<span>Hit enter to search or ESC to close</span>
									</form>
								</div>
							</div>
						</div>
						<div class="close" @click="showSearch = !showSearch">
							<a href="#">
								<span class="close-wrap">
									<span class="close-line close-line1"></span>
									<span class="close-line close-line2"></span>
								</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</transition-group>
	</nav>
</template>

<script>
// import axios from 'axios';
import MenuItem from '../vue/MenuItem.vue';
// import SecondaryMenuItem from '../vue/SecondaryMenuItem.vue';
import MobileMenu from '../vue/MobileMenu.vue';
import Search from '../../images/search.svg';
import Close from '../../images/close.svg';
import CloseButton from './CloseButton.vue';
import TopButton from './TopButton.vue';
import MenuButton from './MenuButton.vue';

export default {
	data() {
		return {
			searchToggled: false,
			topScrollThreshold: 100,
			isScrolled: false,
			window: {
				width: 0,
				height: 0,
			},
			mobileMenuVisible: false,
			show: false,
			showSearch: false,
			showSearchMob: false,
			search: Search,
			close: Close,
			searchIcon: Search,
		};
	},

	props: {
		logo: {},
		language_switcher: {},
		login_link: {},
		currentId: {},
		current_page: {},
		global_settings: {},
		menu: {},
		sec_menu: {},
		mobile_menu: {},
		locale: {},
	},

	computed: {
		parsedMenu() {
			if (this.menu) {
				return JSON.parse(this.menu);
			} else {
				return null;
			}
		},

		parsedSecondaryMenu() {
			if (this.sec_menu) {
				return JSON.parse(this.sec_menu);
			} else {
				return null;
			}
		},

		parsedMobileMenu() {
			if (this.mobile_menu) {
				return JSON.parse(this.mobile_menu);
			} else {
				return null;
			}
		},

		featuredPostsParsed() {
			if (this.featured_posts) {
				return JSON.parse(this.featured_posts);
			} else {
				return null;
			}
		},

		parsedGlobalSettings() {
			if (this.global_settings) {
				return JSON.parse(this.global_settings);
			} else {
				return null;
			}
		},

		parsedCategories() {
			if (this.categories) {
				return JSON.parse(this.categories);
			} else {
				return null;
			}
		},
	},

	watch: {
		searchToggled() {
			this.$nextTick(() => {
				this.focusInput();
			});
		},
	},

	methods: {
		toggleSearch() {
			this.searchToggled = !this.searchToggled;
			this.show = false;
		},

		focusInput() {
			if (this.$refs['search']) {
				this.$refs['search'].focus();
			}
		},

		toggleMobileMenu() {
			this.$store.commit('toggleMobileMenu', !this.$store.state.mobile_menu);
		},

		localeParse(url) {
			if (this.locale != 'en_au') {
				const localeUpdate = new URL(url);
				return '/' + this.locale + localeUpdate.pathname;
			} else {
				return url;
			}
		},

		localeParseSimple(url) {
			if (this.locale != 'en_au') {
				return '/' + this.locale + url;
			} else {
				return url;
			}
		},

		didScroll() {
			var elementTarget = document.querySelector('.site_header');
			this.isScrolled = window.scrollY > elementTarget.offsetHeight + 100;
			this.searchToggled = false;
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},

		localUrlSwap(value) {
			if (window.location.host === 'localhost:3000') {
				return value.replace('live-in-sa.test', 'localhost:3000');
			} else {
				return value;
			}
		},

		closeOnEscape() {
			let the = this;
			document.onkeydown = function (evt) {
				evt = evt || window.event;
				var isEscape = false;
				if ('key' in evt) {
					isEscape = evt.key === 'Escape' || evt.key === 'Esc';
				} else {
					isEscape = evt.keyCode === 27;
				}
				if (isEscape) {
					the.showSearch = false;
					the.showSearchMob = false;
				}
			};
		},

		onTouchStart(event) {
			// Prevent propagation to avoid triggering the onClickOutside immediately
			event.stopPropagation();
		},
		onClickOutside(event) {
			if (
				this.$refs.container &&
				!this.$refs.container.contains(event.target)
			) {
				// Touch event happened outside of the container
				// Perform your desired function here
				this.performFunction();
			}
		},
		performFunction() {
			let the = this;
			// Your function implementation here

			if (the.searchToggled) {
				this.toggleSearch();
			}
		},
	},

	components: {
		MenuItem,
		// SecondaryMenuItem,
		MobileMenu,
		CloseButton,
		TopButton,
		MenuButton,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		window.addEventListener('scroll', this.didScroll);
		this.handleResize();
		this.$store.commit('toggleMobileMenu', false);
	},
	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
		this.closeOnEscape();
		document.addEventListener('touchstart', this.onClickOutside);
		document.addEventListener('mousedown', this.onClickOutside);
	},
	beforeDestroy() {
		document.removeEventListener('touchstart', this.onClickOutside);
		document.removeEventListener('mousedown', this.onClickOutside);
	},
	destroyed() {
		window.removeEventListener('scroll', this.didScroll);
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
		this.$store.commit('toggleMobileMenu', false);
	},
	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_header {
	background: var(--white);
	position: relative;
	z-index: var(--z-index-top);

	@media (max-width: 1279px) {
		border-bottom: unset;
	}

	.desktop_menu {
		&.scrolled {
			position: fixed;
			width: 100%;
			z-index: var(--z-index-top);
			top: 0;
			background: var(--white);
			height: auto;
		}
	}

	.top {
		height: 36px;
		background: var(--gum-green);
		display: flex;
		justify-content: flex-end;
		position: relative;
		z-index: 900;

		.top_button {
			height: 100%;
			border-radius: 0;
			padding: 0 35px;
			background: var(--gum-green);

			@media (max-width: 1279px) {
				padding: 0 24px 0 35px;
			}
		}
	}

	.container {
		display: grid;
		grid-template-columns: auto auto 1fr auto;
		justify-content: space-between;
		align-items: center;

		@media (max-width: 1279px) {
			grid-template-columns: auto 1fr;
		}

		.center {
			display: flex;

			&.center-right {
				justify-content: flex-end;
			}

			ul {
				list-style: none;
				padding: 0;
				margin: 0;
				display: flex;
				flex-direction: row;
				// column-gap: var(--spacer) * 2;
				justify-content: flex-end;
				align-items: center;
				grid-column: span 3;

				> li {
					// margin-right: calc(var(--spacer) * 1);

					&:last-of-type {
						margin-right: 0;
					}

					a {
						color: var(--live-blue);
						text-decoration: none;
						font-weight: 400;
						transition: 0.2s ease all;
						border-bottom: 1px solid transparent;
						padding-bottom: 10px;
						margin-left: 0;

						&:hover {
							border-bottom: 2px solid var(--live-blue);
							transition: 0.2s ease all;
						}
					}

					&.selected {
						a {
							border-bottom: 2px solid var(--live-blue);
							transition: 0.2s ease all;
						}
					}
				}

				> a {
					margin-left: calc(var(--spacer) * 2);
				}
			}
		}

		.right {
			display: flex;
			justify-content: flex-end;
			gap: 16px;
			height: 100%;
			align-items: center;
			right: 0;
			position: absolute;

			@media (max-width: 1279px) {
				position: relative;
				padding-right: 16px;
			}

			.top_button {
				height: 100%;
				border-radius: 0;
				padding: 0 35px;

				@media (max-width: 1279px) {
					padding: 0 35px 0 0;
				}
			}

			.search {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 40px;
				height: 40px;

				&:hover {
					cursor: pointer;
				}

				svg {
					path {
						fill: var(--mid-green);
					}
				}
			}
		}
	}

	&-brand {
		display: flex;

		@media (max-width: $mobile-xl) {
			img {
				height: 40px;
			}
		}
	}

	.mobile_menu {
		width: 100%;
		padding: 0;
		padding: 0;
		background: white;
		height: calc(100vh - 57px);
		position: absolute;
		top: 40px;
		left: 0;
		display: flex;
		flex-direction: column;

		li {
			.menu_cta {
				margin-left: 20px;
				margin-top: 20px;
			}
		}
	}

	.menu_banner {
		width: 100%;
		border-bottom: 1px solid #ccc;
		padding: 10px 20px;
		margin-bottom: 0;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;

		a {
			color: var(--live-blue);
			font-size: 14px;
			line-height: 16.8px;
			font-weight: 600;

			@media (max-width: $mobile) {
				font-size: 18px;
				line-height: 20px;
				align-items: center;
			}

			&:hover {
				cursor: pointer;
			}
		}
	}

	.mobile_menu_nav {
		height: 55px;
		background: white;
		position: relative;
		z-index: 60;
		/* border-bottom: var(--border); */

		@media (max-width: $mobile-xl) {
			gap: 0;
			padding: 0 20px;
		}

		&.scrolled {
			position: fixed;
			/* border-bottom: var(--border); */
			width: calc(100% - 80px);
			top: 0;

			@media (max-width: $mobile-xl) {
				width: calc(100% - 48px);
			}
		}
	}
}

.menu_toggle {
	&:hover {
		cursor: pointer;
	}

	svg {
		path {
			fill: var(--Todmorden-blue);
		}
	}
}

.search-outer-wrapper {
	width: 100%;
	position: fixed;
	top: 56px;
	z-index: 10;

	@media (max-width: $mobile) {
		top: 56px;
	}
}

.search-outer {
	@media (max-width: 767px) {
		top: 56px !important;
	}

	.searchbox {
		.inner-wrap {
			.col {
				padding-left: 0;
				padding-right: 0;
			}
		}
	}
}

.search_dropdown {
	background: var(--warm-grey);
	/* border-top: var(--border); */
	/* border-bottom: var(--border); */
	position: absolute;
	z-index: 0;
	width: 100%;
	top: 100%;
	z-index: 70;

	@media (max-width: 1279px) {
		top: 100%;
	}

	&.scrolled {
		position: fixed;
		top: 56px;

		@media (max-width: $mobile-xl) {
			top: 55px;
		}
	}

	.container {
		@media (max-width: $mobile-xl) {
			grid-template-columns: 16px repeat(6, 1fr) 16px;

			.inner {
				grid-column: 1 / span 8;
			}
		}
	}

	.inner {
		padding: 16px 0;
		grid-column: 1 / span 4;
		display: grid;
		align-items: center;
		grid-template-columns: 20px 1fr auto;
		gap: 20px;
		position: relative;

		@media (max-width: $mobile-xl) {
			padding: 10px 0;
			grid-template-columns: 20px 1fr auto;
			grid-column: 2 / span 2;
		}

		.search_form {
			grid-column: span 3;
			display: flex;
			flex-direction: row;
			align-items: center;
			gap: 10px;

			/* > img {
				@media (max-width: $mobile-xl) {
					display: none;
				}
			} */

			form {
				width: 100%;

				input {
					width: 100%;
					-webkit-appearance: none;
					-moz-appearance: none;
					appearance: none;
					border: 0;
					background: none;
					font: normal normal normal 16px/24px var(--primary-font-family);
					transition: 0.2s ease all;
					outline: none;
					opacity: 0.8;
					color: var(--gum-green);
					/* border-bottom: var(--border); */

					&::-ms-input-placeholder {
						font: normal normal normal 16px/24px var(--primary-font-family);
						color: var(--gum-green);
					}

					&::placeholder {
						font: normal normal normal 16px/24px var(--primary-font-family);
						color: var(--gum-green);
					}
				}
			}

			svg {
				path {
					fill: var(--mid-green);
				}
			}
		}

		> .close_button {
			&::v-deep {
				position: absolute;
				right: 0;

				@media (max-width: $mobile-xl) {
					right: 0;
				}
			}
		}

		label {
			display: flex;
			justify-content: flex-end;
			align-items: center;

			&:hover {
				cursor: pointer;
			}

			span {
				margin-right: 16px;
				font: normal normal 800 14px/18px 'Suisse Intl';
				letter-spacing: 1.4px;
				text-transform: uppercase;
				text-decoration: none;
				transition: 0.2s ease all;
				color: var(--charcoal);

				@media (max-width: $mobile) {
					display: none;
				}
			}

			.close_image {
				display: flex;

				@media (min-width: $mobile) {
					width: 24px;
					height: 24px;
					background: var(--navy);
					border-radius: 50%;
					justify-content: center;
					align-items: center;
					transition: 0.2s ease all;

					&:hover {
						cursor: pointer;
						background: var(--spirit-blue);
						transition: 0.2s ease all;

						svg {
							width: 8px;

							line {
								stroke: var(--white);
								stroke-width: 5px;
							}
						}
					}

					svg {
						width: 8px;

						line {
							stroke: var(--white);
							stroke-width: 5px;
						}
					}
				}
			}
		}
	}
}

.slide-fade-enter-active {
	transition: all 0.25s ease;
}
.slide-fade-leave-active {
	transition: all 0.25s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(100%);
	// opacity: 0;
}

.slide-fade-vert-enter-active {
	transition: all 0.25s ease;
}
.slide-fade-vert-leave-active {
	transition: all 0.25s ease;
}
.slide-fade-vert-enter, .slide-fade-vert-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(-20px);
	opacity: 0;
}

.bounce-enter-active {
	animation: bounce-in 0.15s;
}

.bounce-leave-active {
	animation: bounce-in 0.15s reverse;
}

@keyframes bounce-in {
	0% {
		transform: translateY(-100px);
		opacity: 0;
	}
	// 50% {
	// 	transform: translateY(30px);
	// 	opacity: 1;
	// }
	100% {
		transform: translateY(0px);
		opacity: 1;
	}
}

.fade-enter-active {
	animation: fade-in 0.25s;
}

.fade-leave-active {
	animation: fade-in 0.25s reverse;
}

@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteHeader.vue